import { useStore } from "../../../app/data/root.store";
import { VyzerAIAssistanceIcon } from "../../../assistance/assets/icons";
import { AssistanceHeroLogoText, AssistanceHeroLogoWrapper } from "../../../assistance/components/Assistance.styles";
import { VaultCloseIcon, VaultSecureIcon } from "../../assets/icons";
import { VaultTooltip } from "../../utils/Utils";
import { VAULT_SECURE_TAG_TEXT } from "../Vault.const";
import { VaultClassTags } from "../VaultListTags/VaultClassTag";
import { VaultUploadHeader, VaultUploadHeaderClose, VaultUploadHeaderRight, VaultUploadHeaderSecureTag, VaultUploadHeaderTitle, VaultUploadHeaderTitleLine } from "./VaultModalHeader.styles";

export const VaultModalHeader = ({ onClose, showSecuredButton = true, assetId, createItemsState = false, isCloseButtonDisabled = false }) => {

    const { itemStore } = useStore();
    const asset = itemStore.item;

    const title = createItemsState ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <div>AI import from files</div>
            <AssistanceHeroLogoWrapper style={{ border: 'none' }}>
                <VyzerAIAssistanceIcon />
                <AssistanceHeroLogoText>{'AI-BETA'}</AssistanceHeroLogoText>
            </AssistanceHeroLogoWrapper>

        </div>
    ) : "Upload to Vault";

    return (
        <VaultUploadHeader>
            <VaultUploadHeaderTitle>
                <div>{title}</div>
                {
                    assetId &&
                    <>
                        <VaultUploadHeaderTitleLine />
                        <VaultClassTags linkedAssets={[{ asset }]} minimized={false} alwaysShow={true} />
                    </>
                }
            </VaultUploadHeaderTitle>
            <VaultUploadHeaderRight>
                {
                    showSecuredButton &&
                    <VaultTooltip title={VAULT_SECURE_TAG_TEXT}>
                        <VaultUploadHeaderSecureTag>
                            <VaultSecureIcon />
                            <div>Secured</div>
                        </VaultUploadHeaderSecureTag>
                    </VaultTooltip>
                }
                <VaultUploadHeaderClose disabled={isCloseButtonDisabled} onClick={isCloseButtonDisabled ? undefined : onClose}>
                    <VaultCloseIcon />
                </VaultUploadHeaderClose>
            </VaultUploadHeaderRight>
        </VaultUploadHeader>
    )
};